import { openBlock as a, createElementBlock as n, normalizeClass as i, renderSlot as l } from "vue";
/* empty css                */
const o = /* @__PURE__ */ Object.assign({
  name: "DsIconFrame"
}, {
  __name: "icon-frame",
  props: {
    size: {
      type: String,
      default: "16",
      validator: (e) => /^16|24|40|48$/.test(e)
    },
    alignX: {
      type: String,
      default: "center",
      validator: (e) => /^left|right|center$/.test(e)
    },
    alignY: {
      type: String,
      default: "bottom",
      validator: (e) => /^top|bottom|center$/.test(e)
    },
    debug: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, r) => (a(), n("div", {
      class: i(["icon-frame", [
        { [`icon-frame--size-${e.size}`]: e.size },
        { [`icon-frame--align-x-${e.alignX}`]: e.alignX },
        { [`icon-frame--align-y-${e.alignY}`]: e.alignY },
        { "icon-frame--debug": e.debug }
      ]])
    }, [
      l(t.$slots, "default")
    ], 2));
  }
}), s = o;
export {
  s as default
};
